import { PackagingComponentDto } from './packaging-component-dto';

export class InlayDto extends PackagingComponentDto {
    isRigidComponent = false;
}
